import axiosQlikClient from 'api';
import axiosDBClient from 'axiosDBClient';
import {
  BOOLEAN_TRUE,
  CUSTOMER_VIEW_DETAIL_PAGE,
  INSIGHTBOARD_TILE_LIMIT,
  NUMBER_ZERO,
  SITE_UTILIZATION_TABLE,
  TABLE_NAME_COPAY_ANALYTICS,
  TABLE_NAME_ENGAGEMENT,
  areas,
  EMPTY_OBJECT,
  QUERY_KEY,
  EMPTY_ARRAY,
} from 'constants/constants';
import { trackPromise } from 'react-promise-tracker';
import { getQlikSenseData } from 'services/qlik.service';
import { buildCardDetails, getFieldName } from 'utils/utils';
import {
  setAllAccountOptions,
  setAllInsightView,
  setCards,
  appendCards,
  setColumnRestricted,
  setContacts,
  setExportLoader,
  setFocusAccountChecked,
  setInsightBoards,
  setSelectedInsightView,
  setSelectedTimePeriod,
  setTimePeriodOptions,
  setTimePeriods,
} from './customerViewSlice';
import { setTotalTileCount } from 'store/home/homeMyViewSlice';

/**
 * Get user specific account data from the database
 * that will be displayed in the account dropdown
 * store the accounts in the store
 * @returns
 */
export const getFocusAccountData = (
  unixId,
  roleId,
  field = 'account',
  page
) => {
  return async (dispatch) => {
    const getAccounts = async () => {
      const response = await axiosDBClient.get('filter/corp-parent-priority', {
        params: { unixId, roleId, field },
      });

      if (response.data.error) {
        throw new Error('Could not fetch focus accounts for user ' + unixId);
      }

      return response.data.result;
    };

    try {
      const accounts = await getAccounts();
      dispatch(setAllAccountOptions(accounts));
      if (
        page !== CUSTOMER_VIEW_DETAIL_PAGE ||
        accounts?.length === NUMBER_ZERO
      )
        dispatch(setFocusAccountChecked(accounts?.length > NUMBER_ZERO));
    } catch (error) {
      console.log(error);
    }
  };
};

/**
 * Gets time period data and formats it so
 * the Time Period dropdown can use it
 * also stores time period
 * store the kpi time period in the store
 * @param {*} kpiId the kpi id
 * @returns
 */
export const getTimePeriodData = (kpiId) => {
  return async (dispatch) => {
    const getTimePeriods = async () => {
      const response = await axiosDBClient.get('filter/time-period', {
        params: { kpiId },
      });

      if (response.data.error) {
        throw new Error('Could not fetch products!');
      }
      return response.data.result;
    };

    try {
      const timePeriods = await getTimePeriods();

      const timePeriodOptions = timePeriods.map((timePeriod) => {
        return {
          label: timePeriod.timePeriodName,
          value: timePeriod.timePeriodId,
        };
      });

      dispatch(setTimePeriodOptions(timePeriodOptions));
      dispatch(setTimePeriods(timePeriods));
      let exp = timePeriods.filter((tp) => tp.uXDefaultValue === 'Y')[0];
      dispatch(
        setSelectedTimePeriod({
          label: exp.timePeriodName,
          value: exp.timePeriodId,
        })
      );
    } catch (error) {
      console.log(error.message);
    }
  };
};

/**  MultidimensionAPICall

 */

export const getMultiDimensionChartData = async (
  measureObj,
  dimensionObj,
  appId,
  chartType,
  limit
) => {
  const payload = {
    appId: appId,
    limit: limit,
    measure: measureObj,

    dimension: dimensionObj,
    dataType: chartType,
  };
  let response = await axiosQlikClient.post(
    '/analytics',
    JSON.stringify(payload)
  );
  if (response.data.error) {
    throw new Error('Could not fetch focus ');
  }

  return response.data;
};

export const addToInsightsBoard = async (payload, isUpdate) => {
  const setAddToInsightsBoard = async () => {
    const response = isUpdate
      ? await axiosDBClient.put('v2/customer/add-update-insight-board', {
          ...payload,
        })
      : await axiosDBClient.post('v2/customer/add-update-insight-board', {
          ...payload,
        });

    if (response.data.error) {
      throw new Error('Could not add data!');
    }

    return response.data;
  };

  try {
    const data = await setAddToInsightsBoard();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const updateInsightCardTitle = async (cardId, title, viewId) => {
  const setUpdateMyView = async () => {
    const response = await axiosDBClient.patch(
      `v2/customer/insight-card/title/${cardId}`,
      {
        title: title,
        viewId: viewId,
      }
    );

    if (response.data.error) {
      throw new Error('Could not update Title!');
    }

    return response.data;
  };

  try {
    const data = await setUpdateMyView();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const deleteMyView = async (cardId, positionIndex, unixId) => {
  const setDeleteMyView = async () => {
    const response = await axiosDBClient.delete(
      `v2/customer/insight-card/${cardId}`,
      {
        data: {
          custInsightsBrdId: 1,
          positionIndex: positionIndex,
          unixId: unixId,
        },
      }
    );

    if (response.data.error) {
      throw new Error('Could not delete data!');
    }

    return response.data;
  };

  try {
    const data = await setDeleteMyView();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getQlikDataForCard = async (
  expression,
  dimension,
  appId,
  limit
) => {
  try {
    return await getQlikSenseData(expression, dimension, appId, limit);
  } catch (error) {
    console.log(error.message);
  }
};
export const getInsightViews = async (custInsightsBrdId, type) => {
  const getData = async () => {
    const response = await axiosDBClient.get(
      `v2/view-list/insight-views?custInsightsBrdId=${custInsightsBrdId}&type=${type}`
    );
    return response;
  };
  try {
    return await trackPromise(getData(), 'getView');
  } catch (error) {
    console.log(error);
  }
};
export const addNewInsightView = async (payload, boardpayload) => {
  const response = await axiosDBClient.post('v2/view-list/insight-views', {
    ...payload,
    boardpayload,
  });

  if (response.data.error) {
    throw new Error('Could not add data!');
  }
  return response.data.result;
};

export const renameInsightView = async (payload) => {
  const response = await axiosDBClient.patch(
    `v2/view-list/insight-views/${payload.id}`,
    {
      ...payload,
    }
  );

  if (response.data.error) {
    throw new Error('Could not add data!');
  }

  return response.data;
};

export const deleteInsightView = async (viewId, custInsightsBrdId) => {
  try {
    const response = await trackPromise(
      axiosDBClient.delete(`v2/view-list/insight-views/${viewId}`, {
        data: {
          custInsightsBrdId: custInsightsBrdId,
        },
      }),
      areas.deleteCardsThenView
    );
    return response?.status === 200;
  } catch (error) {
    console.log(error);
  }
};
export const copyViewToInsight = async (payload) => {
  const response = await axiosDBClient.post('v2/view-list/insight-views/copy', {
    ...payload,
  });

  if (response.data.error) {
    throw new Error('Could not copy data!');
  }

  return response.data;
};

export const getCardsData = (
  insightType,
  viewId,
  queryClient,
  offset = NUMBER_ZERO,
  limit = INSIGHTBOARD_TILE_LIMIT
) => {
  return async (dispatch) => {
    // Check if this is a pagination request (offset > 0)
    const isAppend = offset > 0;

    const getCards = async () => {
      const response = await axiosDBClient.get(`v2/customer/insight-card`, {
        params: {
          viewId: viewId,
          insightType: insightType,
          offset: offset,
          limit:
            limit > INSIGHTBOARD_TILE_LIMIT ? INSIGHTBOARD_TILE_LIMIT : limit,
        },
      });

      if (response.data.error) {
        throw new Error('Could not fetch my view data!');
      }
      return response.data;
    };

    try {
      const response = await trackPromise(getCards(), areas.customerView);
      const { data: cards, totalSize } = response?.result;

      if (isAppend) {
        dispatch(appendCards(cards));
      } else {
        dispatch(setCards(cards));
      }

      dispatch(setTotalTileCount(totalSize));

      return response;
    } catch (error) {
      console.log(error);
      if (!isAppend) {
        dispatch(setSelectedInsightView(EMPTY_OBJECT));
        dispatch(setCards(EMPTY_ARRAY));
        dispatch(setAllInsightView(EMPTY_ARRAY));
        dispatch(setTotalTileCount(NUMBER_ZERO));
      }
      return [];
    }
  };
};

export const getAnalyticsData = async (card, queryClient) => {
  try {
    let updatedCard = await buildCardDetails({ ...card }, BOOLEAN_TRUE);

    const params = [
      updatedCard?.advance?.measure,
      updatedCard?.advance?.dimension,
      updatedCard?.appId,
      updatedCard?.advance?.chartType,
      updatedCard?.limit,
    ];

    const queryKey = [QUERY_KEY.TrendsAnalytics, ...params];

    const res = await queryClient.ensureQueryData({
      queryKey: queryKey,
      queryFn: () =>
        trackPromise(getMultiDimensionChartData(...params), updatedCard.cardId),
    });

    return {
      ...updatedCard,
      chartData: res?.data[NUMBER_ZERO],
      chartType: updatedCard?.advance?.chartType,
    };
  } catch (error) {
    console.log(error.message);
    return card;
  }
};

export const addInsightCard = async (payload) => {
  const AddNewCard = async () => {
    const response = await axiosDBClient.post('v2/customer/insight-card', {
      ...payload,
    });
    if (response.data.error) {
      throw new Error('Could not add view');
    }
    return response?.data?.result;
  };
  try {
    return await AddNewCard();
  } catch (error) {
    console.log(error.message);
    return error?.response?.data;
  }
};

export const updateInsightCard = async (payload) => {
  const updateCard = async () => {
    const response = await axiosDBClient.put(
      `v2/customer/insight-card/${payload.cardId}`,
      {
        ...payload,
      }
    );
    if (response.data.error) {
      throw new Error('Could not update card');
    }
    return response.data;
  };
  try {
    const data = await updateCard();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const deleteInsightCard = async (cardId, positionIndex, viewId) => {
  try {
    const response = await axiosDBClient.delete(
      `v2/customer/insight-card/${cardId}`,
      {
        data: {
          positionIndex: positionIndex,
          viewId: viewId,
        },
      }
    );
    if (response.data.error) {
      throw new Error('Could not delete card');
    }
    return response.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getBeamData = async (customerId) => {
  try {
    const response = await trackPromise(
      axiosDBClient.get(`hco/banner/contract/${customerId}`),
      areas.bannerSegment
    );

    if (response?.error) {
      throw new Error('Could not fetch beam chart data');
    }

    const result = response?.data?.result || {};

    const contractSegment =
      result?.contractSegments?.map((item) => ({
        name: item.contractName,
        value: item.sales,
      })) || [];

    const rebate =
      result?.contractSegments
        ?.filter((item) => item.rebate)
        ?.map((item) => ({ name: item.contractName, value: item.rebate })) ||
      [];

    const discount =
      result?.contractSegments
        ?.filter((item) => item.discount)
        ?.map((item) => ({ name: item.contractName, value: item.discount })) ||
      [];

    const membership =
      result?.contractSegments?.find(
        (item) => item.membership && item.membership?.trim() !== ''
      )?.membership || '';

    return {
      contractSegment,
      rebate,
      discount,
      membership,
      id340B: result?.id340B,
    };
  } catch (error) {
    console.log(error);
  }
};

export const getCustomerDetails = async (id, type) => {
  try {
    const getCustomerData = async (id, type) => {
      const response = await axiosDBClient.get('/v2/customer/detail', {
        params: { id, type },
      });

      if (response?.error) {
        throw new Error('Could not fetch customer details');
      }

      return response?.data?.result;
    };
    return await trackPromise(getCustomerData(id, type), areas.bannerSegment);
  } catch (error) {
    console.log(error);
  }
};
export const getPayerPieData = async (mdmId, entityType, type) => {
  try {
    const getPieData = async (mdmId, entityType, type) => {
      const response = await axiosDBClient.get(`/payer/banner`, {
        params: { mdmId, entityType, type },
      });

      if (response?.error) {
        throw new Error('Could not fetch payer pie chart data');
      }

      return response?.data?.result;
    };
    return await trackPromise(
      getPieData(mdmId, entityType, type),
      areas.bannerSegment
    );
  } catch (error) {
    console.log(error);
  }
};

export const getVOCResultApi = async (customerId, customerType) => {
  try {
    const response = await axiosDBClient.get(
      `hco/banner/voc-details/${customerId}`,
      {
        params: { customerType: customerType },
      }
    );

    if (response?.error) {
      throw new Error('Could not fetch CRM data');
    }

    return response?.data?.result;
  } catch (error) {
    console.log(error);
  }
};

export const getCRMLineChart = async (
  expressions,
  dimension,
  appId,
  limit,
  isSortDate
) => {
  try {
    return trackPromise(
      getQlikSenseData(expressions, dimension, appId, limit, isSortDate).then(
        (data) => {
          return data.data;
        }
      ),
      areas.bannerLineChart
    );
  } catch (error) {
    console.log(error);
  }
};

export const getAllInsightBoards = () => {
  return async (dispatch) => {
    const getInsightBoards = async () => {
      const response = await axiosDBClient.get(`customer/insight-board`);

      if (response.data.error) {
        throw new Error('Could not fetch insight boards details');
      }
      return response.data.result;
    };

    try {
      trackPromise(
        getInsightBoards().then((data) => {
          dispatch(setInsightBoards(data));
        }),
        areas.customerViewList
      );
    } catch (error) {
      console.log(error);
    }
  };
};

export const getCustomerContacts = (accountId) => {
  return async (dispatch) => {
    const getContacts = async () => {
      if (!accountId) {
        return [];
      }

      const response = await axiosDBClient.get(
        `customer/contacts/${accountId}`
      );

      if (response.data.error) {
        throw new Error('Could not fetch contacts');
      }

      return response.data.result;
    };

    try {
      const data = await getContacts();

      dispatch(setContacts(data));
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateCardPositions = async (payload) => {
  const updatePositions = async () => {
    const response = await axiosDBClient.put(`customer/insight-card/`, {
      ...payload,
    });

    if (response.data.error) {
      throw new Error('Could not update positions!');
    }

    return response.data;
  };

  try {
    const data = await updatePositions();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getQlikDataforDropdown = async ({
  appId,
  fieldName,
  offset,
  searchText,
  searchOffset,
  account,
  startDate,
  endDate,
  isAccountableProduct,
  selectedProducts,
  selectedSquad,
  field,
  expression,
  payer,
  parentPayer,
  bookOfBusiness,
  isDefault,
}) => {
  const getQlikData = async () => {
    const url =
      searchText === '' ? 'hco/qlik/dropdown-list' : 'hco/qlik/dropdown-search';
    const offsetValue = searchText?.length > 3 ? searchOffset : offset;
    const response = await axiosQlikClient.post(url, {
      appId,
      fieldName,
      offset: offsetValue,
      searchText,
      account,
      startDate,
      endDate,
      isAccountableProduct: isAccountableProduct,
      products: selectedProducts?.map((a) => a.label).join('","'),
      squads: selectedSquad?.map((a) => a.label).join('","'),
      field,
      expression,
      payer: payer?.map((a) => a.label).join('","'),
      parentPayer: parentPayer?.map((a) => a.label).join('","'),
      bookOfBusiness: bookOfBusiness?.map((a) => a.label).join('","'),
      isDefault: isDefault,
    });

    if (response.error) {
      throw new Error('Could not fetch qlik data!');
    }

    return response;
  };

  try {
    const response = await getQlikData();
    return response.data?.result;
  } catch (error) {
    console.log(error.message);
  }
};

export const updateInsightBoardTitle = async (title, insightId) => {
  const updateInsightBoard = async () => {
    const response = await axiosDBClient.put(
      `customer/insight-board/${insightId}`,
      {
        title,
      }
    );
    if (response.data.error) {
      throw new Error('Could not update Insight Board Title!');
    }

    return response.data;
  };

  try {
    const data = await updateInsightBoard();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const updateInsightBoards = async (payload) => {
  const updateInsightBoard = async () => {
    const response = await trackPromise(
      axiosDBClient.patch(`v2/customer/reorder-insight-board`, payload),
      areas.customerViewPinPatch
    );
    if (response.data.error) {
      throw new Error('Could not update Insight Board!');
    }
    return response?.data;
  };

  try {
    const data = await updateInsightBoard();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const shareInsightBoard = async (insightsBoard, shareWith) => {
  const shareInsightBoard = async () => {
    const response = await axiosDBClient.post(
      `v2/customer/share-insight-board`,
      {
        insightsBoard,
        shareWith,
      }
    );
    if (response.data.error) {
      throw new Error('Could not share Insight Board!');
    }

    return response.data.result;
  };

  try {
    const data = await shareInsightBoard();
    return data;
  } catch (error) {}
};

export const notifyRecipientByMail = async (insightsBoard, shareWith) => {
  const notifyRecipientByMail = async () => {
    const response = await axiosDBClient.post(`/notify-user`, {
      insightsBoard,
      shareWith,
    });
    if (response.data.error) {
      throw new Error('Could not notify recipient!');
    }

    return response?.data;
  };

  try {
    const data = await notifyRecipientByMail();
    return data;
  } catch (error) {}
};

export const copyInsightBoard = async (insightBoardFrom, insightBoardTo) => {
  const copyInsightBoard = async () => {
    const response = await axiosDBClient.post(
      `v2/customer/copy-insight-board`,
      {
        insightBoardFrom,
        insightBoardTo,
      }
    );
    if (response.data.error) {
      throw new Error('Could not copy Insight Board!');
    }

    return response.data.result;
  };

  try {
    const data = await copyInsightBoard();
    return data;
  } catch (error) {}
};

export const loadOptions = async (params, isMulti) => {
  try {
    const payload = { ...params, fieldName: getFieldName(params.fieldName) };
    const { values, currentListSize, hasMoreElement } =
      (await getQlikDataforDropdown(payload)) || {};
    const dataOptions = values?.map((item) => ({
      label: item,
      value: item,
    }));
    const options = [...dataOptions];
    return {
      values: options,
      currentListSize,
      hasMoreElement,
    };
  } catch (err) {
    console.log(err); // eslint-disable
  }
};

export const deleteInsightBoard = async (Id) => {
  const setDeleteInsightBoard = async () => {
    const response = await axiosDBClient.delete(
      `v2/customer/insight-board/${Id}`
    );
    if (response.data.error) {
      throw new Error('Could not delete data!');
    }
    return response.data;
  };
  try {
    const data = await setDeleteInsightBoard();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getAffiliationsData = async (
  account,
  offset,
  hcpFlag,
  column,
  order,
  filterExp
) => {
  try {
    const response = await axiosQlikClient.post(`hco/qlik/affiliation`, {
      account,
      offset,
      hcpFlag: hcpFlag || false,
      sortBy: column,
      order: order,
      filterExpression: encodeURIComponent(filterExp),
    });

    if (response.error) {
      throw new Error('Could not fetch qlik data!');
    }

    return response?.data?.result;
  } catch (error) {
    console.log(error.message);
  }
};

export const getAffiliationsDataSite = async (
  account,
  offset,
  hcpFlag,
  column,
  order,
  filterExp,
  corpParent
) => {
  try {
    const response = await axiosQlikClient.post(`hco/qlik/affiliation-site`, {
      account,
      offset,
      hcpFlag: hcpFlag || false,
      sortBy: column,
      order: order,
      filterExpression: encodeURIComponent(filterExp),
      corpParent,
    });

    if (response.error) {
      throw new Error('Could not fetch qlik data!');
    }

    return response?.data?.result;
  } catch (error) {
    console.log(error.message);
  }
};

export const exportData = (
  table,
  account,
  expression,
  timePeriod,
  dimension,
  filterExp,
  columnsToExclude,
  copayDimenssion = '',
  measure = '',
  fileName = ''
) => {
  return async (dispatch) => {
    let payload = { export: true, data: table?.toLowerCase() };
    dispatch(setExportLoader(payload));
    const FileDownload = require('js-file-download');
    const getQlikData = async () => {
      let parameters;
      if (table === 'Affiliation') {
        parameters = {
          table,
          account,
          hcpFlag: expression,
          expression: timePeriod,
        };
      } else if (table === 'SiteAffiliation') {
        parameters = {
          table,
          account,
          filterExpression: encodeURIComponent(filterExp),
        };
      } else if (table === SITE_UTILIZATION_TABLE) {
        parameters = {
          table,
          dimension: encodeURIComponent(account),
          expression: expression,
        };
      } else if (table === TABLE_NAME_COPAY_ANALYTICS) {
        parameters = {
          table,
          dimension: copayDimenssion,
          expression: expression,
          account,
          measureCol: measure,
        };
      } else if (table === TABLE_NAME_ENGAGEMENT) {
        parameters = {
          table,
          expression,
        };
      } else {
        parameters = {
          table,
          account,
          expression,
          timePeriod: timePeriod?.value,
          dimension,
          columnsToExclude: columnsToExclude,
        };
      }

      const response = await axiosQlikClient.post(
        `hco/qlik/export`,
        parameters,
        {
          responseType: 'blob',
        }
      );

      if (response.error) {
        throw new Error('Could not fetch qlik data!');
      }

      payload.export = false;
      dispatch(setExportLoader(payload));
      FileDownload(
        response.data,
        table === TABLE_NAME_COPAY_ANALYTICS
          ? `${fileName}.xlsx`
          : `${table}.xlsx`
      );
      return response;
    };

    try {
      trackPromise(
        getQlikData()
          .then((response) => {})
          .catch((e) => {
            payload.export = false;
            dispatch(setExportLoader(payload));
          })
      );
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const exportTableData = (table, fileName = '', params) => {
  return async (dispatch) => {
    let payload = { export: true, data: table?.toLowerCase() };
    dispatch(setExportLoader(payload));
    const FileDownload = require('js-file-download');

    const getExcelData = async () => {
      const response = await axiosDBClient.post(
        `payer/export-excel`,
        {
          ...params,
        },
        {
          responseType: 'blob',
        }
      );

      if (response.error) {
        throw new Error('Could not fetch qlik data!');
      }

      payload.export = false;
      dispatch(setExportLoader(payload));

      FileDownload(response.data, `${fileName}.xlsx`);

      return response;
    };

    try {
      trackPromise(
        getExcelData()
          .then((response) => {})
          .catch((e) => {
            payload.export = false;
            dispatch(setExportLoader(payload));
          })
      );
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const getSitePerformanceData = async (
  expression,
  offset,
  selectedTimePeriod,
  column,
  order
) => {
  try {
    const response = await axiosQlikClient.post(`hco/qlik/site`, {
      offset,
      expression,
      timePeriod: selectedTimePeriod?.value,
      sortBy: column,
      order: order,
    });

    if (response.error) {
      throw new Error('Could not fetch qlik data!');
    }

    return response?.data?.result;
  } catch (error) {
    console.log(error.message);
  }
};

export const getProductMixData = async (
  expression,
  offset,
  selectedTimePeriod,
  column,
  order
) => {
  try {
    const response = await axiosQlikClient.post(`hco/qlik/product-mix`, {
      offset,
      expression,
      timePeriod: selectedTimePeriod?.value,
      sortBy: column,
      order: order,
    });

    if (response.error) {
      throw new Error('Could not fetch qlik data!');
    }
    return response?.data?.result;
  } catch (error) {
    console.log(error.message);
  }
};

export const loadAccountData = async ({
  offset,
  searchToken,
  filed,
  ecosystems,
  unixId,
  isMyPriority,
}) => {
  try {
    let response = isMyPriority
      ? await axiosDBClient.get('configure-priority/customer', {
          params: { unixId, offset, searchToken, filed, ecosystems },
        })
      : await axiosDBClient.get('/filter/corp-parent', {
          params: { offset, searchToken, filed, ecosystems },
        });
    return response.data;
  } catch (error) {}
};

export const getDarwinReports = async (accountId) => {
  try {
    const response = await axiosQlikClient.get(`qlik/darwin`, {
      params: { accountId },
    });

    if (response?.data?.error) {
      throw new Error('Could not fetch darwin reports data!');
    }

    return response?.data?.values;
  } catch (error) {
    console.log(error);
  }
};

export const getCopayAnalyticsData = async (params) => {
  try {
    const response = await axiosDBClient.post(`hco/qlik/copay`, {
      ...params,
    });

    if (response.error) {
      console.log('Could not fetch copay data!');
      return;
    }

    if (response?.data && response?.data?.result) {
      return response?.data.result;
    }
    return;
  } catch (error) {
    console.log(error.message);
  }
};

export const getSiteUtilizationData = async (
  expression,
  siteUtiliazationType,
  selectedPageIndex,
  column,
  order
) => {
  try {
    const response = await axiosQlikClient.post('hco/qlik/site-utilization', {
      filterExpression: expression,
      siteUtilizationType: siteUtiliazationType,
      sortBy: column,
      order: order,
      offset: selectedPageIndex || NUMBER_ZERO,
    });
    if (response.error) {
      throw new Error('Could not fetch qlik data!');
    }

    return response?.data?.result;
  } catch (error) {
    console.log(error.message);
  }
};
export const getTableRestrictions = () => {
  return async (dispatch) => {
    const getRestrictions = async () => {
      const response = await axiosDBClient.get(
        `role-restriction/restricted-column`
      );
      if (response.error) {
        return;
      }
      return response?.data?.result;
    };
    try {
      const response = await getRestrictions();

      dispatch(setColumnRestricted(response));
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const getPlanData = async (customerId) => {
  try {
    const response = await axiosDBClient.get(`customer/account-plan`, {
      params: { customerId },
    });
    if (response.error) {
      return;
    }
    return response?.data?.result;
  } catch (error) {
    console.log(error.message);
  }
};

export const deletePlanData = async (docId) => {
  try {
    const response = await axiosDBClient.delete(
      `customer/account-plan/${docId}`
    );
    if (response.error) {
      return;
    }
    return response?.status;
  } catch (error) {
    console.log(error.message);
  }
};

export const updatePlanData = async (docId, docName) => {
  try {
    const response = await axiosDBClient.put(
      `customer/account-plan/`,
      JSON.stringify({
        docId: docId,
        docName: docName,
      })
    );
    if (response.error) {
      return;
    }
    return response?.status;
  } catch (error) {
    console.log(error.message);
  }
};

export const addPlanData = async (customerId, docUrl, docName) => {
  try {
    const response = await axiosDBClient.post(
      `customer/account-plan/`,
      JSON.stringify({
        customerId: customerId,
        docUrl: docUrl,
        docName: docName,
      })
    );
    if (response.error) {
      return;
    }
    return response?.status;
  } catch (error) {
    console.log(error.message);
  }
};

export const getAdvanceSearchFieldsData = async (params, options) => {
  try {
    const response = await axiosDBClient.get(`v2/filter/advance`, {
      params: params,
    });
    const result = response.data?.result;
    return {
      data: result?.data ?? [],
      hasMore: result?.hasMoreElement,
      currentListSize: result?.currentListSize,
    };
  } catch (error) {
    console.log(error);
  }
};

export const getCustomerData = async (
  isPriority,
  searchText,
  offset,
  isExactSearch,
  ecosystems,
  flag,
  state,
  zip,
  city,
  userEcosystem
) => {
  try {
    const response = await axiosDBClient.get('v2/filter/customer', {
      params: {
        isPriority,
        searchText,
        offset,
        isExactSearch,
        ecosystems: ecosystems?.length > NUMBER_ZERO ? ecosystems : undefined,
        flag,
        state,
        zip,
        city,
        userEcosystem,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loadDropdownOption = async (params) => {
  try {
    const response = await getPayerDropdownData(params);
    if (response) {
      return {
        values: response?.values ?? [],
        currentListSize: response?.currentListSize,
        hasMoreElement: response?.hasMoreElement,
        totalSize: response?.totalSize,
      };
    }
    return;
  } catch (error) {
    console.log(error);
  }
};

export const getPayerDropdownData = async (params) => {
  try {
    const response = await axiosDBClient.post(`payer/dropdown`, {
      ...params,
    });
    if (response.error) {
      return;
    }

    if (response?.data?.result) {
      return response?.data?.result;
    }
    return;
  } catch (error) {
    console.log(error.message);
  }
};

export const getPayerTimeSpanDates = async (params) => {
  try {
    const response = await axiosDBClient.get(`payer/refresh-dates`, { params });
    if (response.error) {
      return;
    }
    if (response?.data?.result) {
      return response?.data?.result;
    }
    return;
  } catch (error) {
    console.log(error.message);
  }
};

export const getPayerTableData = async (params) => {
  try {
    const response = await axiosDBClient.post(`payer/table/payer-mix`, {
      ...params,
    });
    if (response.error) {
      return;
    }

    if (response?.data?.result) {
      return response?.data?.result;
    }
    return;
  } catch (error) {
    console.log(error.message);
  }
};

export const getPolicyTableData = async (params) => {
  try {
    const response = await axiosDBClient.post(`payer/table/policy-details`, {
      ...params,
    });
    if (response.error) {
      return;
    }

    if (response?.data?.result) {
      return response?.data?.result;
    }
    return;
  } catch (error) {
    console.log(error.message);
  }
};

export const getEcoOpportunityeData = async (params) => {
  try {
    const response = await axiosDBClient.post(`payer/table/eco-opp`, {
      ...params,
    });
    if (response.error) {
      return;
    }

    if (response?.data?.result) {
      return response?.data?.result;
    }
    return;
  } catch (error) {
    console.log(error.message);
  }
};

export const getStakeholderAlertsData = async (params) => {
  try {
    const response = await axiosQlikClient.get('qlik/voc-alerts', {
      params,
    });
    if (response.error) {
      return;
    }

    if (response?.data) {
      return response?.data;
    }
    return;
  } catch (error) {
    console.log(error.message);
  }
};

export const getBobMixData = async (params) => {
  try {
    const response = await trackPromise(
      axiosDBClient.post(`payer/bob-mix`, {
        ...params,
      }),
      areas.bannerBoB
    );
    if (response.error) {
      throw new Error('Could not fetch BoB Mix data!');
    }

    return response?.data?.result?.values || [];
  } catch (error) {
    console.log(error);
  }
};

export const getTimeSpans = async () => {
  try {
    const response = await axiosDBClient.post('hco/refresh-dates');

    if (response.data.error) {
      throw new Error('Could not fetch timespans ');
    }

    return response.data.result;
  } catch (error) {
    console.log(error);
  }
};

export const getGpoSuperGroup = async (customerId) => {
  try {
    const response = await axiosDBClient.get(
      `hco/banner/supergroup-details/${customerId}`
    );

    if (response?.data?.error) {
      throw new Error('Could not fetch super group!');
    }

    return response?.data?.result;
  } catch (error) {
    console.log(error);
  }
};

export const getPathwayData = async (customerId) => {
  try {
    const response = await axiosDBClient.get(
      `hco/banner/pathway/${customerId}`
    );

    if (response?.data?.error) {
      throw new Error('Could not fetch pathway data!');
    }

    return response?.data?.result;
  } catch (error) {
    console.log(error);
  }
};
